<template>
  <h2>404</h2>
  <h3>Sorry, page not found</h3>
</template>

